import "./App.css";
import React from "react";
import Form from "./components/Form";
function App() {
  return (
    <div className="container">
      <h1>Delete your Appispace account</h1>
      <Form />
    </div>
  );
}

export default App;
